import { apiFetch } from '@ami/react/core';

const _baseEndPoint = 'product-group-option-dependencies';

export const DependencyLogic = Object.freeze({
  Any: 'Any',
  All: 'All',
});

export const DependencyConditionTypes = Object.freeze({
  ProductOption: 'Product Option',
  Product: 'Product',
  LuggingIsDirectPinOn: 'Lugging (Direct Pin On)',
  LuggingIsCouplerType: 'Lugging (Coupler Type)',
  LuggingIsCouplerStyle: 'Lugging (Coupler Style)',
  LuggingIsCouplerOilReady: 'Lugging (Coupler Oil Ready)',
});

export class ProductGroupOptionDependencies {
  constructor(item) {
    if (item) {
      this.productGroupId = item.productGroupId;
      this.productGroupName = item.productGroupName;
      this.productOptionDependencies = item.productOptionDependencies;
      this.availableProductOptions = item.availableProductOptions;
      this.availableProducts = item.availableProducts;
      this.availableCouplerStyles = item.availableCouplerStyles;
      return;
    }
    this.productGroupId = null;
    this.productGroupName = null;
    this.productOptionDependencies = [];
    this.availableProductOptions = [];
    this.availableProducts = [];
    this.availableCouplerStyles = [];
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new ProductGroupOptionDependencies(entity);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.productGroupId}`, 'PUT', this);
  }
}
